<script>
  import { Fragment } from 'vue'
  import RequiredLabel from '../components/RequiredLabel'
  import flatFragment from './flatFragment'

  export default {
    name: 'ColumnLayout',

    props: {
      label: {
        type: String,
        default: '',
      },
      comment: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
      columnNum: {
        type: Number,
        default: 1,
      },
    },

    computed: {
      realColumnNum() {
        const count = this.$slots.default().reduce((acc, cur) => {
          const node = cur.type === Fragment ? cur.children : [cur]
          acc.push(...node)
          return acc
        }, []).length

        return this.columnNum ?? (count > 4 ? 4 : count)
      },
    },

    render() {
      const flatten = flatFragment(this.$slots.default())
      return (
        <div>
          <RequiredLabel
            label={this.label}
            comment={this.comment}
            required={this.required}
          />
          <div
            class="column-layout"
            style={{ display: 'flex', flexWrap: 'wrap', margin: '-10px' }}
          >
            {flatten.map((child, i) => (
              <div key={i}
                   style={{
                     padding: '10px',
                     width: `${((1 / this.realColumnNum) * 100).toFixed(2)}100%`,
                   }}
                   class={['item', `column-${this.realColumnNum}`]}>
                {child}
              </div>
            ))}
          </div>
        </div>
      )
    },
  }
</script>
